import axios from 'axios'
import localforage from 'localforage'
localforage.config({ driver: localforage.INDEXEDDB, name: 'localforage', storeName: 'genoplot', });
// Vue 3: globalProperties.$opfs is set by main.js after app creation
let _appInstance = null
export function setAppInstance(app) { _appInstance = app }
import {
    store
} from "@/Store"
import AmplifyEventBus from '@/plugins/aws-amplify-vue/events/AmplifyEventBus';
window.g25cache = window.g25cache || {}
const genoDB = new CacheDB("DB1", "PREFIX1")
import {
    get,
    set,
    keys,
    setMany,
    del,
    delMany,
    getMany
} from '@/plugins/idb-keyval';
let indexDB = {
    get,
    set,
    keys,
    setMany,
    del,
    delMany,
    getMany
}
/*
indexDB.set = async function(key, val) {
console.log('setting', key)
await genoDB.write(key, val)
console.log('set', key)
}
indexDB.get = async function(key) {
console.log('getting', key)
let value = await genoDB.read(key)
console.log('got!!!!!!!!!!!!', value)
return value;
}
*/

function deepFreeze(obj) {
    if (typeof obj === 'object' && obj !== null) {
        if (Array.isArray(obj)) {
            obj.forEach(element => {
                if (typeof element === 'object' && element !== null) {
                    deepFreeze(element); // Recursively freeze array elements
                }
            });
        } else {
            Object.getOwnPropertyNames(obj).forEach(prop => {
                const value = obj[prop];
                if (typeof value === 'object' && value !== null) {
                    deepFreeze(value);
                }
            });
        }
        return Object.freeze(obj);
    }
    return obj;
}

const queryParam = '?v=0.'
let genoplotHandle = false;
let opfs = {
    keys: async function(key) {
        return []
    },
    get: async function(key) {
        try {
            //console.debug('getting cache', key)
            //let value = await genoDB.read(key)
            //return JSON.parse(value)
            let folder = key.split(':')[0]
            //if ( folder == 'rawGroupedSamplesCache' ) console.error('raw samples 2', key);
            let filename = key.split(':')[1]
            const directoryHandle = await genoplotHandle.getDirectoryHandle(folder, {
                create: true
            })
            const fileHandle = await directoryHandle.getFileHandle(filename)
            if (fileHandle) {
                let file = await fileHandle.getFile()
                let contents = await file.text()
                return JSON.parse(contents)
            }
        } catch (err) {
            return false
        }
    },
    set: async function(key, val) {
        let folder = key.split(':')[0]
        let filename = key.split(':')[1]
        let fileHandle
        try {
            //console.debug('setting', key)
            //await genoDB.write(key, JSON.stringify(val))
            let directoryHandle = await genoplotHandle.getDirectoryHandle(folder)
            await directoryHandle.remove({
                recursive: true
            });
            directoryHandle = await genoplotHandle.getDirectoryHandle(folder, {
                create: true
            })
            fileHandle = await directoryHandle.getFileHandle(filename, {
                create: true
            })
        } catch (err) {
            const directoryHandle = await genoplotHandle.getDirectoryHandle(folder, {
                create: true
            })
            fileHandle = await directoryHandle.getFileHandle(filename, {
                create: true
            })
        }
        if (fileHandle) {
            const writableStream = await fileHandle.createWritable();
            await writableStream.write(JSON.stringify(val));
            await writableStream.close();
        }
    }
}
let opfsset;
async function getOpfsOld() {
    //genoplotHandle = false;
    //return;
    try {
        const opfsRoot = await navigator.storage.getDirectory()
        if (opfsRoot) {
            genoplotHandle = await opfsRoot.getDirectoryHandle("genoplot", {
                create: true,
            });
            let fileHandle = await genoplotHandle.getFileHandle('writer', {
                create: true
            })
            let writer = await fileHandle.createWritable()
            await writer.close();
            if (genoplotHandle && !opfsset) {
                if (_appInstance) _appInstance.config.globalProperties.$opfs = opfs;
                opfsset = true;
            }
        }
    } catch (err) {
        console.log('err', err);
        genoplotHandle = false;
    }
}
async function getOpfs() {
    try {
        if (!navigator.storage || !navigator.storage.getDirectory) {
            throw new Error("OPFS not supported");
        }

        const opfsRoot = await navigator.storage.getDirectory();
        const testDir = await opfsRoot.getDirectoryHandle("genoplot", { create: true });
        const testFile = await testDir.getFileHandle("writer", { create: true });

        if (typeof testFile.createWritable !== "function") {
            throw new Error("createWritable not supported");
        }

        const writer = await testFile.createWritable();
        await writer.close();

        genoplotHandle = testDir;

        if (!opfsset) {
            if (_appInstance) _appInstance.config.globalProperties.$opfs = opfs;
            opfsset = true;
        }

    } catch (err) {
        console.log("OPFS disabled:", err.message);
        genoplotHandle = false;
    }
}
getOpfs()
let now = Date.now()
let workers = false;
let exception = false;
let init = Date.now()
let starter = 1;
let maxnum = (navigator.hardwareConcurrency - 1) < 4 ? navigator.hardwareConcurrency - 1 : 4
maxnum = 1;
/*
let pool = {}
for (let n = 1; n < (maxnum + 1); n++) {
    let worker = 'worker' + n;
    pool[worker] = new Worker("./dbWorker.js?v=" + now, {
        name: worker
    })
}
let dbCache = (key, url, timer) => new Promise((res, rej) => {
    const channel = new MessageChannel();
    let w = starter++ % maxnum + 1
    channel.port1.onmessage = ({
        data
    }) => {
        channel.port1.close();
        if (data.error) {
            rej(data.error);
        } else {
            res(data.result);
        }
    };
    pool['worker' + w].postMessage([key, url, timer], [channel.port2]);
});
async function initWorkers() {
    dbCache('workersStarted', '/workers.json', Date.now()).then(res => {
        console.debug(`Workers initialized: ${Date.now() - init} ms`, pool)
        exception = true
    })
}
initWorkers()
*/

function findLocalItems(prefix, ckey) {
    var i, results = [];
    for (i in localStorage) {
        if (localStorage.hasOwnProperty(i)) {
            if (i.includes(prefix) && i !== ckey) {
                results.push(i);
            }
        }
    }
    return results;
}
async function cleanup() {
    let started = Date.now()
    let allkeys = await indexDB.keys()
    let prefixes = {}
    allkeys.map(async key => {
        let prefix = key.split(':')[0]
        if (!prefixes[prefix]) {
            let matched = allkeys.filter(x => x.split(':')[0] == prefix && x.split(':')[0] != "workersStarted")
            if (matched.length > 1) {
                let delkeys = matched.sort((x, y) => x.split(':')[1] && parseInt(x.split(':')[1]) > y.split(':')[1] && parseInt(y.split(':')[1]) ? 1 : -1)
                delkeys.splice(-1)
                console.debug('deleting', delkeys)
                prefixes[prefix] = true;
                await indexDB.delMany(delkeys)
            }
        }
    })
}
if (!window.__cleanupIndexedDb) {
    window.__cleanupIndexedDb = true;
    setInterval(() => {
        cleanup()
    }, 300000)
}
cleanup();
async function deleteKeys(ckey, indexedDB) {
    try {
        let prefix = ckey.split(':')[0] + ':'
        let deleteSet = []
        if (indexedDB == 'local') {
            deleteSet = findLocalItems(prefix, ckey)
        } else {
            let keys = await indexedDB.keys()
            deleteSet = keys.filter(key => key.includes(prefix) && (key !== ckey))
        }
        if (deleteSet.length) {
            if (indexedDB == 'local') {
                deleteSet.map(x => {
                    localStorage.removeItem(x)
                })
            } else {
                await indexedDB.delMany(deleteSet)
            }
        }
    } catch (err) {
        console.debug(err);
    }
}
let storagekeys = {
    getRawGroups: 'calcVersion',
    getRawAncientgroups: 'calcVersion',
}
let indexDBCache = {
    getAll: async function(cache, module, stage, exclusion) {
        let caches = Object.keys(indexDBCache).filter(x => x != 'getAll' && !exclusion.some(y => y == x))
        console.debug(`Caching ${module}:`, caches)
        let cacheArray = caches.map(async x => {
            await indexDBCache[x](cache, module, stage)
        })
        let cached = await Promise.all(cacheArray)
    },
    getMapCalcs: async function(cache, module, stage) {
        //console.log('getMapCalcs', cache, module, stage);
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : typeof(cache) == 'object' ? cache : {}
        } catch (err) {}
        if (!genoplotHandle) {
            await getOpfs()
        }
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `mapcalcs:${cache.calcVersion}`
        let url = `https://static.genoplot.com/${stage}public/mapCalculators${queryParam + (cache.mapCalc || Date.now())}`
        //console.log('getting', url);
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.mapCalc) {
                    await indexedDB.set(key, str)
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                    }, 10)
                }
            } else {}
        }
        console.debug(`getMapCalcs ${module} cache...`, `${Date.now() - started} ms`)
        localforage.setItem('`getMapCalcs', str);
        g25cache.getMapCalcs = str
        return str
    },
    getRawGroups: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        if (!genoplotHandle) {
            await getOpfs()
        }
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `rawgroups:${cache.calcVersion}`
        let url = `https://static.genoplot.com/${stage}public/rawgroups${queryParam + cache.calcVersion}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.calcVersion) {
                    await indexedDB.set(key, str)
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                    }, 10)
                }
            } else {}
        }
        console.debug(`getRawGroups ${module} cache...`, `${Date.now() - started} ms`)
        g25cache.getRawGroups = str
        localforage.setItem('getRawGroups', str);
        return str
    },
    getRawAncientgroups: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `rawAncientgroups:${cache.calcVersion}`
        let url = `https://static.genoplot.com/${stage}public/rawAncientgroups${queryParam + cache.calcVersion}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.calcVersion) {
                    await indexedDB.set(key, str)
                    setTimeout(() => {
                        deleteKeys(key, indexedDB)
                    }, 0)
                }
            } else {}
        }
        console.debug(`getRawAncientgroups ${module} cache...`, `${Date.now() - started} ms`)
        g25cache.getRawAncientgroups = str
        localforage.setItem('getRawAncientgroups', str);
        return str
    },
    getAdmixCalculators: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `admixCalculators:${cache.calcVersion}`
        let url = `https://static.genoplot.com/${stage}public/admixCalculators${queryParam + cache.calcVersion}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await localStorage.getItem(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.calcVersion) {
                    g25cache.getAdmixCalculators = str
                    await localStorage.setItem(key, JSON.stringify(str))
                    setTimeout(() => {
                        deleteKeys(key, 'local')
                    }, 0)
                }
            } else {}
        }
        console.debug(`getAdmixCalculators ${module} cache...`, `${Date.now() - started} ms`)
        str = typeof(str) == 'object' ? str : JSON.parse(str)
        g25cache.getAdmixCalculators = str
        str = typeof(str) == 'object' ? str : JSON.parse(str)
        localforage.setItem('getAdmixCalculators', str);
        return str
    },
    getCalculators: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `calculators:${cache.calcVersion}`
        let url = `https://static.genoplot.com/${stage}public/calculators${queryParam + cache.calcVersion}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
                g25cache.getCalculators = str
            }
        } else {
            str = await indexedDB.get(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                str = str.filter(x => x.public == 1)
                if (str && cache.calcVersion) {
                    g25cache.getCalculators = str
                    await indexedDB.set(key, str)
                    setTimeout(() => {
                        deleteKeys(key, indexedDB)
                    }, 0)
                }
            } else {}
        }
        console.debug(`getCalculators ${module} cache...`, `${Date.now() - started} ms`)
        try {
            let i = 0;
            while (i < str.length) {
                str[i].label = decodeURIComponent(str[i].calculator)
                i++
            }
        } catch (err) {
            console.log('decodeURIComponent', err)
        }
        //str = str.filter(x => x.type == 'G25' || !x.type)
        g25cache.getCalculators = str ? deepFreeze(str) : str;
        localforage.setItem('getCalculators', str);
        return g25cache.getCalculators
    },
    getG25Groups: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        try {
            if (typeof(cache) != 'object') {
                cache = JSON.parse(cache)
            }
        } catch (err) {}
        let started = Date.now();
        let key = `groups.g25:${cache.groups.g25}`
        let url = `https://static.genoplot.com/${stage}groups/g25${queryParam + cache.groups.g25}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.groups.g25) {
                    await indexedDB.set(key, str)
                    str = response.data;
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                    }, 10)
                }
            } else {}
        }
        console.debug(`getG25Groups ${module} cache...`, `${Date.now() - started} ms`)
        localforage.setItem('getG25Groups', str);
        g25cache.getG25Groups = str
        return str
    },
    getSampleGroups: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `samplegroups:${cache.samples}`
        let url = `https://static.genoplot.com/public/samplegroups${queryParam + cache.samples}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            //str = await genoDB.read(key)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.samples) {
                    await indexedDB.set(key, str)
                    //await genoDB.write(key, JSON.stringify(str))
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                        //await deleteKeys(key, 'local')
                    }, 10)
                }
            } else {}
        }
        console.debug(`getSampleGroups ${module} cache...`, `${Date.now() - started} ms`)
        g25cache.getSampleGroups = str
        localforage.setItem('getSampleGroups', str);
        return str
    },
    getRawGroupsCache: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let indexedDB
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `rawGroupsCache:${cache.samples}`
        let url = `https://static.genoplot.com/${stage}public/rawGroupsCache${queryParam + cache.samples}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(url)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.samples) {
                    await indexedDB.set(key, str)
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                    }, 10)
                }
            } else {}
        }
        console.debug(`getRawGroupsCache ${module} cache...`, `${Date.now() - started} ms`)
        g25cache.getRawGroupsCache = str
        localforage.setItem('getRawGroupsCache', str);
        return str
    },
    getRawGroupedSamplesCache: async function(cache, module, stage) {
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        window.__testStarted = Date.now()
        let indexedDB
        let marker = 'indexDB';
        if (!genoplotHandle) {
            await getOpfs()
        }
        if (genoplotHandle) {
            indexedDB = opfs;
            marker = 'opfs'
        } else {
            indexedDB = indexDB
        }
        let started = Date.now();
        let key = `rawGroupedSamplesCache:${cache.samples}`
        let url = `https://static.genoplot.com/${stage}public/rawGroupedSamplesCache${queryParam + cache.samples}`
        let str;
        if (workers) {
            //console.debug(`getRawGroupedSamplesCache started ${Date.now() - window.__testStarted} ms`)
            let result = await dbCache(key, url, Date.now())
            //console.debug(`getRawGroupedSamplesCache got cache ${Date.now() - window.__testStarted} ms`)
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await indexedDB.get(key)
            //console.error(`getRawGroupedSamplesCache got cache 2 ${marker} |${key}|  ${Date.now() - window.__testStarted} ms`)
            if (!str) {
                let response = await axios.get(url)
                //console.error(`getRawGroupedSamplesCache got asxios ${marker} |${key}| ${Date.now() - window.__testStarted} ms`)
                str = response.data;
                if (str && cache.samples) {
                    await indexedDB.set(key, str)
                    setTimeout(async () => {
                        await deleteKeys(key, indexedDB)
                    }, 10)
                }
            } else {}
        }
        //console.debug(`getRawGroupedSamplesCache sent response ${Date.now() - window.__testStarted} ms`)
        console.debug(`getRawGroupedSamplesCache ${module} cache...`, `${Date.now() - started} ms`)
        g25cache.getRawGroupedSamplesCache = str
        localforage.setItem('getRawGroupedSamplesCache', str);
        return str
    },
    getTreeDataCache: async function(cache, module, stage) {
        console.log('cache', cache);
        try {
            cache = typeof(cache) == 'string' ? JSON.parse(cache) : cache
        } catch (err) {}
        let started = Date.now();
        //cache.pcaversion = cache.pcaversion || started
        let key = `treeData:${cache.pcaversion}`
        let url = `https://static.genoplot.com/${stage}public/treeData${queryParam + cache.pcaversion}`
        let str;
        if (workers) {
            let result = await dbCache(key, url, Date.now())
            if (result && !result.error) {
                str = result.result
            }
        } else {
            str = await localStorage.getItem(`treeData:${cache.pcaversion}`)
            if (!str) {
                let response = await axios.get(url)
                str = response.data;
                if (str && cache.samples) {
                    await localStorage.setItem(key, JSON.stringify(str))
                    setTimeout(async () => {
                        await deleteKeys(key, 'local')
                    }, 10)
                }
            } else {}
        }
        console.debug(`getTreeData ${module} cache...`, `${Date.now() - started} ms`)
        str = typeof(str) == 'object' ? str : JSON.parse(str)
        g25cache.getTreeDataCache = str
        localforage.setItem('getTreeDataCache', str);
        return str
    }
}
const ifObjectisJSON = function(obj) {
    return (typeof obj === 'object' && obj !== null && obj.constructor === Object) || Array.isArray(obj)
}

function CacheDB(namespace, prefix, config) {
    this.config = config || {
        auto: 0
    };
    this.config.auto = this.config.auto || 0
    this.namespace = namespace || "CacheDBDefaultNameSpace";
    this.prefix = prefix || "CacheDBDefaultPrefix";
    this.read = async function(key, config) {
        config = config || {};
        config.type = config.type || (this.config.auto ? "auto" : "text");
        return new Promise((resolve, reject) => {
            caches.open(this.namespace)
                .then(cache => {
                    cache.match(new Request(`https://${this.prefix}/${encodeURIComponent(key)}`))
                        .then(async response => {
                            if (!response) {
                                reject(false);
                                return;
                            }
                            if (config.type === 'auto') {
                                switch (response.headers.get('Content-Type')) {
                                    case "application/json":
                                        config.type = "json";
                                        break;
                                    case "application/octet-stream":
                                        config.type = "arrayBuffer";
                                        break;
                                    case "application/octet-stream":
                                        config.type = "blob";
                                        break;
                                    case "text/number":
                                        config.type = "number";
                                        break;
                                    case "text/boolean":
                                        config.type = "boolean";
                                        break;
                                    default:
                                        config.type = "text";
                                        break;
                                }
                            }
                            switch (config.type) {
                                case "number":
                                    resolve(Number(await response.text()));
                                    return;
                                case "json":
                                    resolve(response.json());
                                    return;
                                case "arrayBuffer":
                                    resolve(response.arrayBuffer());
                                    return;
                                case 'blob':
                                    resolve(response.blob());
                                    return;
                                case 'text':
                                    resolve(response.text());
                                    return;
                                case 'boolean':
                                    resolve(await response.text() == 1);
                                    return;
                                default:
                                    resolve(response.body);
                                    return;
                            }
                        })
                })
                .catch(err => {
                    console.error('CacheDB Read Erorr:' + err);
                    reject(null);
                });
        })
    }
    this.write = async function(key, value, config) {
        config = config || {};
        config.type = config.type || (this.config.auto ? "auto" : "text");
        if (config.type === 'auto')
            config.type = ifObjectisJSON(value) ? 'json' : typeof value;
        switch (config.type) {
            case "json":
                config.content_type = "application/json";
                value = JSON.stringify(value);
                break;
            case "arrayBuffer":
                config.content_type = "application/octet-stream";
                break;
            case 'blob':
                config.content_type = "application/octet-stream";
                break;
            case 'number':
                config.content_type = "text/number";
                value = value.toString();
                break;
            case 'boolean':
                config.content_type = "text/boolean";
                value = value ? 1 : 0
                break;
            default:
                break;
        }
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                cache.put(
                    new Request(`https://${this.prefix}/${encodeURIComponent(key)}`),
                    new Response(value, {
                        headers: {
                            'Content-Type': config.content_type
                        }
                    })).then(resolve(1))
            }).catch(err => {
                console.error('CacheDB Write Erorr:' + err);
                reject(0)
            });
        })
    }
    this.delete = async function(key) {
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                    cache.delete(new Request(`https://${this.prefix}/${encodeURIComponent(key)}`))
                        .then(resolve(true))
                })
                .catch(err => {
                    console.error('CacheDB Delete Erorr:' + err);
                    reject(false)
                });
        })
    }
    this.list = async function() {
        return new Promise((resolve, reject) => {
            caches.open(this.namespace).then(cache => {
                cache.keys().then(keys => {
                    resolve(keys.map(key => decodeURIComponent(key.url.split('/').pop())));
                })
            }).catch(err => {
                console.error('CacheDB List Erorr:' + err);
                reject([])
            });
        })
    }
    this.all = async function() {
        const data = {};
        return new Promise(async (resolve, reject) => {
            this.list().then(async keys => {
                await Promise.all(keys.map(async key => {
                    data[key] = await this.read(key);
                }))
                resolve(data);
            }).catch(err => {
                console.error('CacheDB All Erorr:' + err);
                reject([])
            });
        })
    }
    this.clear = async function() {
        return new Promise((resolve, reject) => {
            this.list().then(keys => {
                keys.forEach(key => {
                    this.delete(key)
                })
                resolve(true);
            }).catch(err => {
                console.error('CacheDB Clear Erorr:' + err);
                reject(false)
            });
        })
    }
    this.destroy = async function() {
        return new Promise((resolve, reject) => {
            this.clear().then(() => {
                caches.delete(this.namespace).then(resolve(true));
            }).catch(err => {
                console.error('CacheDB Destroy Erorr:' + err);
                reject(false)
            });
        })
    }
}
const dbCacheFunctions = {}

dbCacheFunctions.saveCache = async function(cacheVer, stage) {
    console.log('setting new cacheVersion', stage, cacheVer)
    try {
    cacheVer = JSON.parse(cacheVer)
    }
    catch(err) {
    }
    localStorage.setItem('cacheVer', JSON.stringify(cacheVer));
    await indexDBCache.getAll(cacheVer, 'global', stage, [])
    AmplifyEventBus.emit('appEvents', {
        exec: 'refreshCache',
        component: 'global',
        params: cacheVer
    })
}

dbCacheFunctions.cacheAll = async function(cacheVer, stage) {
    if (cacheVer && stage) {
        dbCacheFunctions.saveCache(cacheVer, stage)
    } else {
        let stage = store.getters.get('env') === 'production' ? '' : 'staging/';
        let currentDT = Math.floor(Date.now() / 1000);
        store.commit('change', {
            showlab: false
        });
        store.commit('change', {
            routeKey: 0
        });
        let cache = localStorage.getItem('cacheVer')
        let cacheVer;
        try {
            cacheVer = JSON.parse(cache);
        } catch (err) {}
        cacheVer = cacheVer || {
            groups: {
                g25: currentDT
            },
            samples: currentDT,
            tos: 0,
            calcVersion: currentDT
        }
        await indexDBCache.getAll(cacheVer, 'global', stage, [])
        axios.get(`https://static.genoplot.com/${stage}cacheVer?v=${Date.now()}`).then(async response => {
            var cache = response.data.cache;
            var cacheVer = JSON.stringify(response.data.cache);
            var currentVer = localStorage.getItem('cacheVer') ? localStorage.getItem('cacheVer') : "none"
            if (cacheVer != currentVer) {
                dbCacheFunctions.saveCache(cacheVer, stage)
            }
        });
    }
}
AmplifyEventBus.on('appEvents', info => {
    if (info && typeof(info) == 'object' && info.component == 'dbCache' && info.params && info.exec == 'saveCache' && info.params.calcVersion) {
        let stage = store.getters.get('env') === 'production' ? '' : 'staging/';
        let cacheVer = JSON.stringify(info.params);
        dbCacheFunctions.saveCache(cacheVer, stage)
    }
})
export { dbCacheFunctions }
export default indexDBCache
